import { PredictedLineupsHp, IPredictedLineupsHp, } from "@sky-it-livedata/livedata-sports-design-system";

import { WidgetContext } from "../../types/WidgetContext";
import { log } from "../../utils/log";
import { LmpPredictedLineupsQuery } from "./types";

import transformer from "./transformers/query";
import { useIntcmp } from "../../hooks/useIntcmp";

export const setCustomAttributes = ({
  variables,
}: WidgetContext<LmpPredictedLineupsQuery>) => {
  return {
    variables: JSON.stringify(variables),
  };
};

export const getServerProps = ({
  props,
}: WidgetContext<LmpPredictedLineupsQuery>): IPredictedLineupsHp => {
  return transformer(props);
}

const LmpPredictedLineupsWidget = ({
  props,
  ...rest
}: WidgetContext<IPredictedLineupsHp>) => {
  log({ props, ...rest });
  const intCmpEventHandler = useIntcmp();

  return (
    <div onClick={intCmpEventHandler}>
        <PredictedLineupsHp {...props} />
    </div>
  );
}

export default LmpPredictedLineupsWidget;